import * as THREE from 'three';
import Application from '../Application';
import BakedModel from '../Utils/BakedModel';
export default class Environment {
    constructor() {
        this.application = new Application();
        this.scene = this.application.scene;
        this.resources = this.application.resources;
        this.bakeModel();
        this.setModel();
    }
    bakeModel() {
        this.bakedModel = new BakedModel(this.resources.items.gltfModel.environmentModel, this.resources.items.texture.environmentTexture, 900);
    }
    setModel() {
        const model = this.bakedModel.getModel();
        // model.position.set(0, 0, -10000); // Adjust the position as needed
        model.traverse((child) => {
            if (child instanceof THREE.Mesh) {
                child.receiveShadow = true;
            }
        });
        this.scene.add(model);
    }
    update() { }
}
